import * as keyapis_rfidregistry_v1_record_pb from "./v1/keyapis_rfidregistry_record_v1.pb";
import * as keyapis_rfidregistry_v1_system_pb from "./v1/keyapis_rfidregistry_system_v1.pb";

export default {
  v1: {
    resources: {
      record: keyapis_rfidregistry_v1_record_pb,
      system: keyapis_rfidregistry_v1_system_pb,
    },
  },
};
